const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Length of the enrolment window, in days.
 *
 * The sidebar is the only remaining promo surface and it renders for the first
 * 14 days after enrolment, so the preloader uses the same window — preloading
 * beyond it would issue AGG queries for a surface that can never render.
 */
export const ENROLMENT_WINDOW_DAYS = 14;

/**
 * Compute full 24-hour periods elapsed since enrolment.
 * Returns 0 when the date string is absent (not enrolled yet).
 */
export function getDaysSinceEnrolment(enrolmentDateStr: string | null | undefined): number {
	if (!enrolmentDateStr) {
		return 0;
	}
	return Math.floor((Date.now() - new Date(enrolmentDateStr).getTime()) / MS_PER_DAY);
}

/**
 * Returns true when the experiment is still within its active window:
 * - Not yet enrolled (null/undefined) → false, the experiment should not activate
 * - Enrolled within windowDays → true
 * - Enrolled longer ago → false
 */
export function isWithinEnrolmentWindow(
	enrolmentDateStr: string | null | undefined,
	windowDays: number = ENROLMENT_WINDOW_DAYS,
): boolean {
	if (!enrolmentDateStr) {
		return false;
	}
	return getDaysSinceEnrolment(enrolmentDateStr) <= windowDays;
}
